import React, { useEffect, useState } from "react";
import DecorativeSquares from "../components/ui/DecorativeSquares";
import Search from "../components/form/Search";
import CalendarPopover from "../components/popup/CalendarPopover";
import Ordertab from "../components/Tab/Ordertab";
import Add from "../components/button/Add";
import Plan from "../components/Modals/Plan";
import AddCustomerfalse from "../components/Modals/AddCustomerfalse";
import { useNavigate } from "react-router-dom";

const Order = () => {
  const navigate = useNavigate();
  const [selectPlan, setSelectPlan] = useState(false);
  const [isRegtrue, setIsRegtrue] = useState(false);
  const [search, setSearch] = useState("");
  const [dateRange, setDateRange] = useState({
    start_date: null,
    end_date: null,
  });
  const isTrue = localStorage.getItem("is_reg_completed");
  const handleAddPlan = () => {
    if (isTrue === "false") {
      setIsRegtrue(true);
      return;
    }
    setSelectPlan(true);
  };

  const formatDisplayDate = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    return d.toLocaleDateString("en-US", {
      month: "short",
      day: "2-digit",
      year: "numeric",
    });
  };

  const clearDateFilter = () => {
    setDateRange({
      start_date: null,
      end_date: null,
    });
  };

  return (
    <>
      <section className=" max-w-7xl rounded-md mx-auto p-4 mt-4 md:mt-5">
        <DecorativeSquares />
        <div className=" md:bg-white md:shadow-sm rounded-md mx-auto p-0 lg:p-6 max-w-7xl">
          <div className="text-center md:text-start space-y-2 mb-4 w-full mx-auto relative">
            <h1 className="text-[#191919] text-2xl md:text-3xl font-bold">
              Orders
            </h1>
            <p className=" text-sm text-[#747474]">
              All Orders Added By Your Customers Appear Here
            </p>

            <div className="hidden md:block absolute top-0 right-0">
              <Add addClickEvent={handleAddPlan} />
            </div>
          </div>
          <div className="block md:hidden border-b mt-2 mb-2 text-gray-100 w-full shadow-xl"></div>

          <div className="space-y-4 max-w-7xl bg-none ">
            <div>
              <Ordertab
                search={search}
                setSearch={setSearch}
                start_date={dateRange.start_date}
                end_date={dateRange.end_date}
              />
            </div>
          </div>
          <div className="md:hidden">
            <Add
              addClickEvent={handleAddPlan}
              extraClasses="fixed bottom-28 right-4 sm:bottom-20 sm:right-6 z-40"
            />
          </div>

          {/* Modal to select plan for adding orders */}
          <Plan
            open={selectPlan}
            onClose={() => setSelectPlan(false)}
            from={"order"}
          />
        </div>
      </section>
      {isRegtrue && (
        <AddCustomerfalse
          open={isRegtrue}
          onClose={() => setIsRegtrue(false)}
          onConfirm={() => {
            setIsRegtrue(true);
            navigate("/set-up");
          }}
        />
      )}
    </>
  );
};

export default Order;
